import { AppConfig } from '../config';
import { TokenRefreshService } from '../services/tokenRefreshService';

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem(AppConfig.tokenKey);

  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(url, { ...options, headers, cache: 'no-store' });

  const newToken = response.headers.get('X-Access-Token');
  if (newToken) {
    TokenRefreshService.updateToken(newToken);
  }

  return response;
}
